export default "__VITE_ASSET__CXzCkma___"